import { useEffect } from "react";

/* ================================================================
   useFokusfalla — håller tangentbordsfokus inne i en öppen dialog
   (DS Del J4, UX-granskning U26/U32/U37 2026-10-26).

   - Vid öppning: fokus till första fokuserbara elementet (eller det
     som har data-autofokus).
   - Tab/Shift+Tab stegar runt inom dialogen.
   - Esc anropar onStang (om den finns).
   - Vid stängning: fokus tillbaka till elementet som hade fokus innan.
   ================================================================ */
const FOKUSERBARA =
  'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export default function useFokusfalla(ref, oppen, onStang) {
  useEffect(() => {
    if (!oppen) return undefined;
    const tidigare = document.activeElement;
    const rot = ref.current;
    if (rot) {
      const forst = rot.querySelector("[data-autofokus]") || rot.querySelector(FOKUSERBARA);
      // Fältet kan redan ha fått fokus av anroparen; rör det då inte.
      if (forst && !rot.contains(document.activeElement)) forst.focus();
    }
    const onKey = (e) => {
      const el = ref.current;
      if (!el) return;
      if (e.key === "Escape" && onStang) {
        e.preventDefault();
        onStang();
        return;
      }
      if (e.key !== "Tab") return;
      const lista = Array.from(el.querySelectorAll(FOKUSERBARA)).filter((n) => n.offsetParent !== null);
      if (!lista.length) return;
      const forsta = lista[0];
      const sista = lista[lista.length - 1];
      if (e.shiftKey && (document.activeElement === forsta || !el.contains(document.activeElement))) {
        e.preventDefault();
        sista.focus();
      } else if (!e.shiftKey && (document.activeElement === sista || !el.contains(document.activeElement))) {
        e.preventDefault();
        forsta.focus();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      if (tidigare && typeof tidigare.focus === "function" && document.contains(tidigare)) tidigare.focus();
    };
    // onStang får vara en ny funktion vid varje render utan att fällan byggs om.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oppen]);
}
